import React from 'react';
import PropTypes from 'prop-types';
import StrModal from '../../shared/StrModal';
import { useFileUpload } from "./useFileUpload";
import FileUpload from "./FileUploadModal";


const CaptionsField = (props) => {
    const [modalOpen, setModalOpen] = React.useState(false);

    const handleOpenModalClick = () => {
        setModalOpen(true);
    };

    const {
        status,
        filename,
        filePayload,
        error,
        uploadFile,
        uploadPercent
    } = useFileUpload('/srt_file');

    const closeModal = () => setModalOpen(false);

    React.useEffect(
        function uploadSuccess() {
            if (status === 'success') {
                setModalOpen(false);
            }
        },
        [status]
    );

    React.useEffect(
        function updateCaptionsUrl() {
            if (filePayload) {
                props.onSrtFileUrlChange(filePayload.srt_file_url);
            }
        },
        [filePayload]
    );


    if (modalOpen) {
        return (
          <StrModal title="Upload SRT File" open hideModal={closeModal}>
            <FileUpload
              filename={filename}
              loading={status === 'loading'}
              error={error}
              onUpload={uploadFile}
              uploadPercent={uploadPercent}
            />
          </StrModal>
        );
    } else {
        return (
          <>
            {props.srtFileUrl ? (
              <>
                <div
                  className="thumbnail-container col-xs-4"
                  style={{
                                backgroundImage: `url('https://image.flaticon.com/icons/png/512/29/29546.png')`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center'
                            }}
                />
                <div className="change-logo-container col-xs-6">
                  <button
                    type="button"
                    onClick={handleOpenModalClick}
                    tabIndex={0}
                    className="btn btn-secondary clickable"
                  >
                                Change
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary clickable ml1"
                    onClick={() => props.onSrtFileUrlChange(null)}
                    tabIndex={0}
                  >
                                Delete
                  </button>
                </div>
              </>
                ) : (
                  <button
                    type="button"
                    onClick={handleOpenModalClick}
                    tabIndex={0}
                    className="add-logo-button mt2"
                    disabled={props.disabled}
                  >
                        Add Captions
                  </button>
                )}
          </>
        );
    }
};

CaptionsField.propTypes = {
    srtFileUrl: PropTypes.string,
    onSrtFileUrlChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

CaptionsField.defaultProps = {
    disabled: false
}

export default CaptionsField;
